import React, { useState } from "react"
import { Container, Row, Col } from "reactstrap"
import TaskList from "../../TaskManagement/TaskList"
import TaskManagementListHeader from "../../TaskManagement/TaskManagementListHeader"
import "./TasksTab.css"


const TasksTab = ({ incidentId }) => {
    const [orderBy, setOrderBy] = useState(['-date_added'])
    const [filterValues, setFilterValues] = useState({ searchTerm: '', incidentId: incidentId, isArchived: false })
    const boardId = process.env.REACT_APP_INCIDENT_BOARD_ID

    return (
        <Container fluid className="incident-tasks-container">
            <div className="info-container mt-0">
                <TaskManagementListHeader
                    activeTab="all"
                    parentBoardId={boardId}
                    filterValues={filterValues}
                    setFilterValues={(res) => setFilterValues({ ...res })}
                    incidentId={incidentId}
                />
                <Row>
                    <Col className="TaskListColumn">
                        <TaskList {...filterValues} orderBy={orderBy} />
                    </Col>
                </Row>
            </div>
        </Container>
    )
}

export default TasksTab
